import { render, staticRenderFns } from "./SubUnitShow.vue?vue&type=template&id=157c9170&scoped=true&"
import script from "./SubUnitShow.vue?vue&type=script&lang=ts&"
export * from "./SubUnitShow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157c9170",
  null
  
)

export default component.exports